export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[960px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                黑料吃瓜网
              </span>
            </div>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              全网最新最全的娱乐八卦资讯平台，提供黑料吃瓜网站入口与最新网址，手机版免费观看，每日更新不迷路。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-100 text-sm mb-4">快速导航</h3>
            <div className="space-y-2">
              <a href="#hero" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              <a href="#ranking" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
              <a href="#cards" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">最新爆料</a>
              <a href="#carousel" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#updates" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">实时快讯</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-100 text-sm mb-4">联系与投稿</h3>
            <div className="space-y-2">
              <a href="#contact" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">投稿爆料</a>
              <a href="#faq" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
              <a href="#comments" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">读者热评</a>
              <a href="#topics" className="block text-xs md:text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a>
            </div>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-100 text-sm mb-4">合作伙伴</h3>
            <p className="text-xs md:text-sm text-background-400 leading-relaxed">
              诚邀优质内容平台与媒体机构合作，共同打造健康丰富的娱乐资讯生态。
            </p>
          </div>
        </div>

        <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2024 黑料吃瓜网 - 最新地址网址入口官网直达手机版。本站内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#faq" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}